import { UniqueAllocation } from '@/src/types';
import { GameModel, GameState, GoldState, gameModel } from '../models/game-model';

export enum SymbolState {
    Error = -1,
    Available,
    Allocated
}

export class SymbolService {
    public static get Instance(): SymbolService {
        return this._instance || (this._instance = new SymbolService());
    }
    private static _instance: SymbolService;

    private symbolStateValidation(_symbolID: number): boolean {
        if (gameModel.symbolStates[_symbolID] !== SymbolState.Available) {
            return false;
        }
        return true;
    }

    public allocate(_symbolID: number): UniqueAllocation {
        if (gameModel.gameState !== GameState.IN_PLAY) {
            return;
        }

        // Check symbol can be opened.
        if (!this.symbolStateValidation(_symbolID)) {
            console.warn('symbol already used');
            return undefined;
        }

        // Check there is an available state.
        const ticketSymbolIndex = gameModel.ticketStates.indexOf(SymbolState.Available);
        if (ticketSymbolIndex === SymbolState.Error) {
            console.warn('out of range ticket symbol request');
            return undefined;
        }

        // Return the symbol and set state to allocated.
        let allocatedSymbol: number = gameModel.ticketSymbols[ticketSymbolIndex] - 1;

        // Check for special symbol.
        let goldenPrize: boolean = false;
        if (allocatedSymbol === GameModel.SPECIAL_SYMBOL - 1) {
            goldenPrize = true;
            allocatedSymbol = gameModel.goldPrize;
            gameModel.gameState = GameState.PAUSED;
            gameModel.goldState = GoldState.TRANS_ON;
        }

        gameModel.symbolStates[_symbolID] = SymbolState.Allocated;
        gameModel.ticketStates[ticketSymbolIndex] = SymbolState.Allocated;
        return { allocatedSymbol: allocatedSymbol, uniqueTicketID: ticketSymbolIndex, goldenPrize: goldenPrize };
    }

    public avalibleSymbol(): number {
        // Filter the indices where the value is 0
        const zeroIndices = gameModel.symbolStates.map((value, index) => (value === SymbolState.Available ? index : SymbolState.Error)).filter((index) => index !== SymbolState.Error);

        if (zeroIndices.length > 0) {
            // Generate a random index from the filtered zeroIndices
            const randomIndex = zeroIndices[Math.floor(Math.random() * zeroIndices.length)];
            return randomIndex;
        }

        // Not found.
        return SymbolState.Error;
    }

    public countedSymbols(): number {
        const symbolsAllocated: number = gameModel.symbolStates.reduce((count, state) => count + (state === SymbolState.Allocated ? SymbolState.Allocated : SymbolState.Available), SymbolState.Available);
        return symbolsAllocated;
    }
}

export const symbolService = SymbolService.Instance;
